import * as yup from "yup";

const schema = yup.object({
	id: yup.number(),
	name: yup.string().trim().required("Module Name is required").min(1, "Module Name minimum length is 1").max(30, "Module Name maximum length is 30"),
	shortName: yup.string().trim().required("Module Short Name is required").matches(/^[A-Za-z_]+$/, "Only English letters and underscores are allowed.").min(1, "Module Short Name minimum length is 1").max(10, "Module Short maximum length is 10"),
	remark: yup.string().min(0).max(100)
})


export default schema